import React, { ReactNode } from "react"
import { Link, MenuItem } from "@chakra-ui/react"

type Props = {
  children: ReactNode
}

const MenuItemLink = ({ children }: Props) => (
  <Link
    fontWeight="semibold"
    color="black"
    _hover={{ textDecoration: "none" }}
  >
    <MenuItem>{children}</MenuItem>
  </Link>
)

export default MenuItemLink
